<template>
  <div >
    <div class="logo2 bg-white " :class="{'bg-jacarta-900': darkMode}">
      <img src="~/assets/logo_dark1.png" alt="logo">
      <div class=" loader92 mt-5 ml-2 "> </div>
      <div class="my-5 dark:text-gray-300"><slot/></div>
    </div>
  </div>
</template>
<script setup>

const darkMode = useCookie('theme')
</script>
<style>

.logo2 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}


.loadingfixed {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.loader92 {

  width: 16px;
  height: 16px;
  position: relative;
  left: -15px;
  border-radius: 50%;

  background: currentColor;
  box-shadow: 32px 0, -32px 0, 64px 0;
}

.loader92::after {
  content: '';
  position: absolute;
  left: -32px;
  top: 0;
  width: 16px;
  height: 16px;
  border-radius: 10px;
  background: #db2777;
  animation: moveda 3s linear infinite alternate;
}

@keyframes moveda {

  0%,
  5% {
    left: -32px;
    width: 16px;
  }

  15%,
  20% {
    left: -32px;
    width: 48px;
  }

  30%,
  35% {
    left: 0px;
    width: 16px;
  }

  45%,
  50% {
    left: 0px;
    width: 48px;
  }

  60%,
  65% {
    left: 32px;
    width: 16px;
  }

  75%,
  80% {
    left: 32px;
    width: 48px;
  }

  95%,
  100% {
    left: 64px;
    width: 16px;
  }
}</style>